<template>
  <div class="container d-flex fd-column SECTION">
    <div class="h3 text-bold p-x-1:mo p-b-2">
      <div>{{content.title}}</div>
    </div>
    <div class="d-flex w-100 fd-column:mo flex-0-1 STEP-SECTION" >
      <div
          v-for="(step, index) in content.steps"
          :key="index"
          class="STEP"
      >
        <div class="d-flex fd-column ITEM p-b-2">
          <img
              class="IMAGE m-b-3"
              :src="step.image"
              :alt="step.altText"
          /><div class="h5 text-bold p-x-1:mo m-b-1 ">{{step.title}}</div>
          <p class="p-x-1:mo">{{step.description}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'how-it-works-section',
  computed: {
    ...mapGetters('homepage/contentful', [
      'proHomePage',
    ]),
    content () {
      return this.proHomePage.howItWorksSection;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@homeservices/design-kit/tools";
  .SECTION {
    margin-bottom: 8 * $unit;
    margin-top:100px;
  }
  .STEP-SECTION {
    display: flex;
    flex: 1 1 auto;
  }
  .STEP {
    @include desktop () {
      margin-right: 16px;
    }
  }
  .STEP:nth-child(3) {
      margin-right: 0px;
    }
  .ITEM {
    max-width: 395px;
    text-align: left;
  }
  .IMAGE {
    align-self: center;
    width: 100%;
    height: auto;
  }
</style>
